module.exports = __webpack_public_path__ + "img/minpian.5d6b9cbe.jpg";